// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drawing-symbol-picker{display:flex;gap:4px;flex-wrap:wrap}.drawing-symbol-picker button{padding:3px;border:1px solid #8885;background:transparent;border-radius:3px;cursor:pointer;font-size:22px}", ""]);
// Exports
module.exports = exports;
